export default "__VITE_ASSET__37c25b47__"